<template>
    <div class="page" :class="{ 'page__has-bar': !readonly }">
        <div class="page__bd">
            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__hd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">单据编号</label>
                        <em class="weui-form-preview__value">{{ form.main.mr_code }}</em>
                    </div>
                </div>
                <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
                    <div class="weui-form-preview__item" slot="mr_macode_f">
                        <label class="weui-form-preview__label">{{ customLabel.mr_macode_f || "转出工单" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_macode_f }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="mr_prcode_f">
                        <label class="weui-form-preview__label">{{ customLabel.mr_prcode_f || "转出产品编号" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_prcode_f }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="pr_detail_f">
                        <label class="weui-form-preview__label">{{ customLabel.pr_detail_f || "转出产品名称" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.pr_detail_f }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.mr_qty" slot="mr_qty">
                        <label class="weui-form-preview__label">{{ customLabel.mr_qty || "套数" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_qty }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="mr_macode_t">
                        <label class="weui-form-preview__label">{{ customLabel.mr_macode_t || "转入工单" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_macode_t }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="mr_prcode_t">
                        <label class="weui-form-preview__label">{{ customLabel.mr_prcode_t || "转入产品编号" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_prcode_t }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="pr_detail_t">
                        <label class="weui-form-preview__label">{{ customLabel.pr_detail_t || "转入产品名称" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.pr_detail_t }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.mr_whname" slot="mr_whname">
                        <label class="weui-form-preview__label">{{ customLabel.mr_whname || "仓库" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_whname }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="mr_date">
                        <label class="weui-form-preview__label">{{ customLabel.mr_date || "单据日期" }}</label>
                        <span class="weui-form-preview__value">{{ dateFormat(form.main.mr_date) }}</span>
                    </div>
                    <div class="weui-form-preview__item" slot="mr_dpname">
                        <label class="weui-form-preview__label">{{ customLabel.mr_dpname || "部门名称" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_dpname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.mr_remark" slot="mr_remark">
                        <label class="weui-form-preview__label">{{ customLabel.mr_remark || "备注" }}</label>
                        <span class="weui-form-preview__value">{{ form.main.mr_remark }}</span>
                    </div>
                </custom-layout>
            </div>

            <collapse class="form-preview weui-form-preview" :title="'明细（' + form.items.length + '条）'">
                <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items" :key="item.id">
                    <div class="form-detail-preview_num">{{ item.md_detno }}</div>
                    <custom-layout :view-config="customViewConfig" position="detail1">
                        <div class="weui-form-preview__item" slot="md_mmdetno_f">
                            <label class="weui-form-preview__label">{{ customLabel.md_mmdetno_f || "转出行" }}</label>
                            <span class="weui-form-preview__value">{{ item.md_mmdetno_f }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="md_mmdetno_t">
                            <label class="weui-form-preview__label">{{ customLabel.md_mmdetno_t || "转入行" }}</label>
                            <span class="weui-form-preview__value">{{ item.md_mmdetno_t }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="md_prcode">
                            <label class="weui-form-preview__label">{{ customLabel.md_prcode || "物料编号" }}</label>
                            <span class="weui-form-preview__value">{{ item.md_prcode }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="pr_detail">
                            <label class="weui-form-preview__label">{{ customLabel.pr_detail || "物料名称" }}</label>
                            <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
                            <label class="weui-form-preview__label">{{ customLabel.pr_orispeccode || "型号" }}</label>
                            <span class="weui-form-preview__value">{{ item.pr_orispeccode }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.pr_spec" slot="pr_spec">
                            <label class="weui-form-preview__label">{{ customLabel.pr_spec || "规格" }}</label>
                            <span class="weui-form-preview__value">{{ item.pr_spec }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.pr_brand" slot="pr_brand">
                            <label class="weui-form-preview__label">{{ customLabel.pr_brand || "品牌" }}</label>
                            <span class="weui-form-preview__value">{{ item.pr_brand }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="md_mmremain_f">
                            <label class="weui-form-preview__label">{{ customLabel.md_mmremain_f || "转出行结存" }}</label>
                            <span class="weui-form-preview__value">
                                <span>{{ numberFormat(item.md_mmremain_f, '#,##0.#') }}</span>
                                &nbsp;{{ item.pr_unit }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="md_mmqty_t">
                            <label class="weui-form-preview__label">{{ customLabel.md_mmqty_t || "转入行需求" }}</label>
                            <span class="weui-form-preview__value">
                                <span>{{ numberFormat(item.md_mmqty_t, '#,##0.#') }}</span>
                                &nbsp;{{ item.pr_unit }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="md_qty">
                            <label class="weui-form-preview__label">{{ customLabel.md_qty || "挪料数量" }}</label>
                            <span class="weui-form-preview__value">
                                <span>{{ numberFormat(item.md_qty, '#,##0.#') }}</span>
                                &nbsp;{{ item.pr_unit }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.md_remark" slot="md_remark">
                            <label class="weui-form-preview__label">{{ customLabel.md_remark || "备注" }}</label>
                            <span class="weui-form-preview__value">{{ item.md_remark }}</span>
                        </div>
                    </custom-layout>
                </div>
            </collapse>
        </div>

        <div class="footer-bar weui-dialog__ft" v-if="!readonly">
            <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_primary"
                @click="f_audit">审核</a>
            <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_default"
                @click="p_remove">删除</a>
        </div>
    </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import Collapse from "@/components/Collapse.vue";

export default {
    mixins: [form],
    components: {
        CustomLayout,
        Collapse
    },
    data() {
        return {
            baseUrl: "/api/make/relocation",
            codeField: "mr_code",
            statusField: "mr_statuscode",
            caller: "MakeRelocation",
            xtype: "make-relocation-formpanel",
        };
    }
};
</script>